import { Alert, Button, Chip, CircularProgress, Container } from "@mui/material";
import Box from "@mui/material/Box";
import React, { useCallback, useEffect, useState } from "react";
import { BRAND_URL } from "../../Constants/Constants";
import AxiosInstance from "../../services/AxiosInstance";
import AppTableView from "../AppTableView";
import BrandDialog from "./BrandDialog";
import { useAlert } from "../alerts/AlertContext";

const statusColors = {
  open: "#007BFF",
  "in-progress": "#FD7E14",
  hold: "#FFC107",
  resolved: "#20C997",
  closed: "#6C757D",
};

function Brand() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const showAlert = useAlert();

  const getBrandData = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await AxiosInstance.get(BRAND_URL);
      setData(response.data || []);
    } catch (error) {
      console.error("Error fetching branding data:", error);
      setError("Failed to load branding data. Please try again.");
      // showAlert("Failed to load statuses", "error");
    } finally {
      setLoading(false);
    }
  }, [showAlert]);

  useEffect(() => {
    getBrandData();
  }, [getBrandData]);

  const columns = [
    {
      field: "productTitle",
      flex: 1,
      headerName: "Product Title",
      renderCell: (params) => params.value,
    },
    {
      field: "companyName",
      flex: 1,
      headerName: "Company Name",
      renderCell: (params) => params.value,
    },
    {
      field: "contactEmail",
      flex: 1,
      headerName: "Contact Email",
      renderCell: (params) => params.value,
    },    
    {
      field: "supportEmail",
      flex: 1,
      headerName: "Support Email",
       renderCell: (params) => params.value,
    },
    {
      field: "contactPhone",
      flex: 1,
      headerName: "Contact Phone",
       renderCell: (params) => params.value,
    },
     {
      field: "footerLogoName",
      flex: 1,
      headerName: "Footer Logo",
       renderCell: (params) => params.value,
    },
    {
      field: "faviconLogoName",
      flex: 1,
      headerName: "Favicon Logo",
       renderCell: (params) => params.value,
    },
    {
      field: "globalLogoName",
      flex: 1,
      headerName: "Global Logo",
       renderCell: (params) => params.value,
    },
    {
      field: "action",
      flex: 1,
      headerName: "Actions",
      disableColumnMenu: true,
      sortable: false,
      renderCell: (params) => (
        <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
          <BrandDialog
            brandId={params.row.id}
            brandName="Edit"
            variant="link"
          />
        </Box>
      ),
    },
  ];

  //if error content
  if (error) {
    return (
      <Container>
        <Alert
          severity="error"
          action={
            <Button color="inherit" size="small" onClick={getBrandData}>
              Retry
            </Button>
          }
          sx={{ borderRadius: 2 }}
        >
          {error}
        </Alert>
      </Container>
    );
  }

  return (
    <Box
      sx={{
        borderRadius: "8px",
        overflow: "hidden",
        p: 2,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100%",
      }}
    >
      {/* loading or content */}
      {loading ? (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100%",
          }}
        >
          <CircularProgress />
        </Box>
      ) : (
        <AppTableView rows={data} cols={columns} initialPageSize={5} />
      )}
    </Box>
  );
}

export default Brand;
